import { render } from "./Column.vue?vue&type=template&id=50c437a8&scoped=true"
import script from "./Column.vue?vue&type=script&lang=js"
export * from "./Column.vue?vue&type=script&lang=js"

import "./Column.vue?vue&type=style&index=0&id=50c437a8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50c437a8"]])

export default __exports__